import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import { textToBase64Barcode } from "common/services/barcodeService";


// Create styles
// Unit is "pt" which is the default in react-pdf
const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFF',
    margin: '0pt',
    padding: '0pt',
  },
  content: {
    marginLeft: '180pt', // 63mm (180pt) 210
    fontSize: '10pt',
  },
  title: {
    fontSize: '14pt',
    top: '100pt',
  },
  formNafn: {
    marginLeft: '60pt',
    top: '185pt',
    display: 'flex',
    flexDirection: 'row'
  },
  textNafn: {
    display: 'flex',
    // flexDirection: 'row',
    width: '238pt'
  },
  // textKennitala: {
  //   display: 'flex',
  //   flexDirection: 'row',
    // },
  formHusheiti: {
    marginLeft: '60pt',
    top: '235pt' //'195pt'
  },
    formSveitarfelag: {
    position: 'absolute', // Position absolutely within the page
    top: '262pt',
    right: '120pt',
    display: 'flex'
  },
  textSveitarfelag: {
    width: '220pt'
  },
  barcode: {
    top: '320pt',
    height: '60pt',
    width: '170pt',
    marginLeft: '110pt',
  },
});

// Create Document Component
const UmslagToPdf = ({ kjosandi, activeKosning }) => {

  // Only render the barcode for voters in Reykjavík (norður/suður)
  // Condition: sveitarfelag === "Reykjavík" | sveitarfelagsnumer === "0000"
  // const renderBarcode = () => {
  //   if (kjosandi.sveitarfelag === "Reykjavík" ||true) {
  //     return (
  //       <View style={styles.barcode}>
  //         <Image src={barcodeBase64} />
  //       </View>
  //     );
  //   }

  //   return null;
  // }

  // Annoying manipulation to accomodate requirements
  // from Reykjavik to show norður/suður depending on kjordæmi.
  // kjördæmi = 1 => suður
  // kjördæmi = 2 => norður
  const getDisplayFormatForSveitarfelag = () => {
    if (kjosandi.numerKjordaemis === 5) {
      return `${kjosandi.sveitarfelag} suður`;
    } else if (kjosandi.numerKjordaemis === 6) {
      return `${kjosandi.sveitarfelag} norður`;
    } else {
      return kjosandi.sveitarfelag;
    }
  };

  return (
    <Document title={`Umslag-${kjosandi.kennitala}-${activeKosning.id}`}>
      <Page size="B5" orientation="landscape" style={styles.page}>
        <View style={styles.content}>
          <View style={styles.title}>
            <Text>{activeKosning.lysing}</Text>
          </View>

          <View style={styles.formNafn}>
            <Text style={styles.textNafn}>{kjosandi.nafn}</Text>
            {/* <Text style={styles.textKennitala}>{kjosandi.kennitala}</Text> */}
          </View>
          <View style={styles.formHusheiti}>
            <Text>{kjosandi.husheiti}</Text>
          </View>
          <View style={styles.formSveitarfelag}>
                      <Text>
              {getDisplayFormatForSveitarfelag()} - {kjosandi.kjorstadurNumer} / {kjosandi.kjordeild}
            </Text>
            {/* <Text>{kjosandi.kjordaemi}</Text> */}
          </View>
          <View style={styles.barcode}>
            <Image src={textToBase64Barcode(kjosandi.kennitala)} />
          </View>
          {/* {renderBarcode()} */}
        </View>
      </Page>
    </Document>
  );
  
};

export default UmslagToPdf;